import React, { useRef, useState } from 'react';
import Select, { components } from 'react-select';
// import Pagination from './pagination'
import LeadDetailTabs from './LoanFiledTabs';
import ReactPaginate from 'react-paginate';
import { Tooltip } from 'react-tippy';
import crypto from "../../../config/crypto";
import { Link } from 'react-router-dom';
import { UPDATE_CUSTOMER_STATUS } from '../../../services/inventory-funding/opsee.gql';
import { executeGraphQLMutation } from '../../../services/inventory-funding/executeGraphQLQuery';
import { toast } from 'react-toastify';
import { useApolloClient } from '@apollo/client';
import { FCI_ADMIN_ACCESS_ROLE } from '../../../config/IFConstant';

const { ValueContainer, Placeholder } = components;

const CustomValueContainer = ({ children, ...props }) => {
    return (
        <ValueContainer {...props}>
            <Placeholder {...props} isFocused={props.isFocused}>
                {props.selectProps.placeholder}
            </Placeholder>
            {React.Children.map(children, child =>
                child && child.type !== Placeholder ? child : null
            )}
        </ValueContainer>
    );
};

const REOPEN_REASONS = [
  {
    id: 1,
    label: "Customer Now Interested",
    value: "Customer Now Interested"
  },
  {
    id: 2,
    label: "Customer Available for Verification",
    value: "Customer Available for Verification"
  },
  {
    id: 3,
    label: "Customer Requested Revisit",
    value: "Customer Requested Revisit"
  },
  {
    id: 4,
    label: "Incorrect Rejection",
    value: "Incorrect Rejection"
  },
  {
    id: 5,
    label: "Data Updated / Corrected",
    value: "Data Updated / Corrected"
  },
  {
    id: 6,
    label: "Admin Approval for Reopen",
    value: "Admin Approval for Reopen"
  },
  {
    id: 7,
    label: "Exception Case Approval",
    value: "Exception Case Approval"
  },
  {
    id: 8,
    label: "Credit Decision Reconsidered",
    value: "Credit Decision Reconsidered"
  },
  {
    id: 9,
    label: "Additional Documents Received",
    value: "Additional Documents Receive"
  },
  {
    id: 10,
    label: "Risk Reassessment Approved",
    value: "Risk Reassessment Approved"
  },
  {
    id: 0,
    label: "Other (Requires Comment)",
    value: "Other"
  }
];

const CustomerListTable = (props) => {
  const client = useApolloClient();
  let pageCount = Math.ceil(props.pageCount / 10);
  let customerViewList = props.customerViewList;
  const tipContentRef = useRef(null);
  const [toggleTip, setToggleTip] = useState(null);
  const [rejectModal, setRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState({});
  const [reopenModal, setReopenModal] = useState(false);
  const [reopenReason, setReopenReason] = useState({});

  const cancelCustomerTask = () => {
    props.setLoading(true);
    let variables= {
      "updateCustomerInput": {
        source:"opsee",
        type: "reject",
        customer_id:rejectReason?.customer_id || 0,
        rejection_reasons: rejectReason?.id === 0 ? rejectReason?.other_reason : rejectReason?.value,
      }
    }
    executeGraphQLMutation(UPDATE_CUSTOMER_STATUS(),variables,client).then(res=> {
        hideRejectModal();
        toast.success(res?.data?.update_customer_status?.message);
        props.getCustomerViewList(props.filterData,props.offset)
        props.setLoading(false)
    }).catch(error=> {
        props.setLoading(false)
        toast.error(error.toString().replace('ApolloError:',''));
    })
  };
  
  const reopenCustomerTask = () => {
    props.setLoading(true);
    let variables= {
      "updateCustomerInput": {
        source:"opsee",
        type: "reopen",
        customer_id:reopenReason?.customer_id || 0,
        reopen_reasons: reopenReason?.id === 0 ? reopenReason?.other_reason : reopenReason?.value,
      }
    }
    executeGraphQLMutation(UPDATE_CUSTOMER_STATUS(),variables,client).then(res=> {
        hideReopenModal();
        toast.success(res?.data?.update_customer_status?.message);
        props.getCustomerViewList(props.filterData,props.offset)
        props.setLoading(false)
    }).catch(error=> {
        props.setLoading(false)
        toast.error(error.toString().replace('ApolloError:',''));
    })
  };
  
  const showRejectModal = (customer_id) => {
    setRejectReason({customer_id})
    setRejectModal(true);
    document.body.classList.add("overflow-hidden");
  }

  const hideRejectModal = () => {
    setRejectModal(false);
    setRejectReason({});  
    document.body.classList.remove('overflow-hidden');
  };

  const showReopenModal = (customer_id) => {
    setReopenReason({customer_id})
    setReopenModal(true);
    document.body.classList.add("overflow-hidden");
  }

  const hideReopenModal = () => {
    setReopenModal(false);
    setReopenReason({});  
    document.body.classList.remove('overflow-hidden');
  };

  const handlePagenationClick = (e) => {
    const selectedPage = e.selected;
    props.handlePageClick(selectedPage);
};

  return (
    <>
      <div className="lead-list-data-table fci-list-table">
        <table>
          <thead>
            <tr>
              <th>Customer ID</th>
              <th>Customer</th>
              <th>Co-borrower</th>
              <th>Task Summary</th>
              <th>Created to Completed Tat</th>
              <th>Overall Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {customerViewList?.customer_list?.length > 0 ? (
                customerViewList.customer_list.map((task) => (
                <tr key={task.id}>
                    <td>
                      {/* <div className="table-txt-data"> */}
                        <h4>{task.id} <span className={`lead-type ${task.lead_type === 'if' ? 'lead-type-bg' : ''}`}>{task.lead_type}</span></h4>
                        <span>Created on {task.created_date}</span>
                      {/* </div> */}
                    </td>

                    {/* PB Details */}
                    <td>
                    <div className="table-txt-data">
                        <h5>{task.pb_full_name || '-'}</h5>
                        <span>{task.pb_mobile || '-'}</span>
                    </div>
                    </td>

                    {/* CB Details */}
                    <td>
                    <div className="table-txt-data">
                        <h5>{task.cb_full_name || '-'}</h5>
                        <span>{task.cb_mobile || '-'}</span>
                    </div>
                    </td>

                    {/* Survey Type */}
                    <td>{task.completed_tasks}/{task.total_tasks} Completed <span onClick={()=> setToggleTip(toggleTip === task.id ? null : task.id)}><i className='ic-info-icon1'></i></span>
                      <Tooltip
                        html={(
                            <div ref={tipContentRef} className="controlled-example tooltip-main">
                                <div className="tooltip-data">
                                    <span className="controlled-example_close-button" onClick={()=>setToggleTip(null)}><i className="ic-clearclose"></i></span>
                                    <ul className="tooltip-user-detail-span-label">
                                    {task.surveys?.map((survey, index) => (
                                      <li key={index}>{survey.survey_name}&nbsp;&nbsp;
                                       {survey.is_completed === '1' ? <a className='ic-check'></a> : <></>}
                                      </li>
                                    ))}
                                    </ul>
                                </div>
                            </div>
                        )}
                        open={toggleTip === task.id}
                        tagName="span"
                        position="bottom"
                        trigger="click"
                        interactive={true}
                        animateFill={false}
                        arrow={true}
                        arrowSize="small"
                        className="tootip-outer"
                        forceDirection
                    ></Tooltip>
                    </td>

                    {/* Address */}
                    <td>{task.created_to_completed_tat || '-'}</td>

                    <td style={{"color": `${task.overall_status === 'Survey Pending' ? 'red' : task.overall_status === 'Survey Cancelled' ? '#FFA340' : '#30b38a'}`}}>{task.overall_status || '-'}</td>

                    {/* Actions */}
                    <td>
                    <ul className="action-btn">
                        <li>
                        <Link
                            to={`/inventory-funding/fci-lead-detail/${crypto.encode(task.id)}`}
                            className="btn btn-default"
                        >
                            <i className="ic-remove_red_eyevisibility"></i>
                        </Link>
                        </li>
                        {(props?.logInUserInfo?.role_id?.includes(FCI_ADMIN_ACCESS_ROLE) || props?.logInUserInfo?.role_id?.includes(-1)) && 
                        <>
                        <li onClick={()=> showRejectModal(task.id)} title='Reject Tasks'>
                        <i className="ic-rejected">
                          <i className='path1'></i>
                            <i className='path2'></i>
                            <i className='path3'></i>
                            <i className='path4'></i>
                            <i className='path5'></i>
                            <i className='path6'></i>
                            <i className='path7'></i>
                            <i className='path8'></i>
                        </i>
                        </li>
                        <li onClick={()=> showReopenModal(task.id)} title='Reopen Tasks'>
                          <i className='ic-replay'></i>
                        </li></>}
                    </ul>
                    </td>
                </tr>
                ))
            ) : (
                <tr>
                <td colSpan="8" className="text-center">
                    No records found
                </td>
                </tr>
            )}
          </tbody>

        </table>
        <div className='pagination-bx' id="dealerList">
                    <ReactPaginate
                        previousLabel={"<"}
                        nextLabel={">"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        forcePage = {props.offset}
                        pageRangeDisplayed={5}
                        onPageChange={handlePagenationClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"} />
                </div >
      </div>

      <div className="view-login-popup caluction-popup-outer cancellation-flow">
        <Modal
          show={rejectModal}
          handleClose={hideRejectModal}
        >
          <div className='mrp-heading-txt'>
          <h2 className='mmvdetailsph-title'>Cancel Customer Tasks</h2>
          </div>
          <div className="modal-header">
          </div>
          <div className="modal-body">
            <fieldset className="single-select">
              <div className="material">
                <Select
                  components={{ ValueContainer: CustomValueContainer }}
                  options={customerViewList?.rejection_reasons}
                  placeholder="Cancel Reasons"
                  className="react-select"
                  classNamePrefix="react-select"
                  value={customerViewList?.rejection_reasons?.filter(v=> v.value === rejectReason?.value)}
                  onChange={(e) =>
                    setRejectReason((prev)=>({...prev,id:e.id,value:e.value,}))
                  }
                />
              </div>
            </fieldset>
            &nbsp;
            &nbsp;
            {rejectReason?.id === 0 && 
            <fieldset className="form-filed">
              <div className="material">
                <input
                  id="value"
                  type="text"
                  placeholder=""
                  name="value"
                  className="form-input"
                  autoComplete="off"
                  value={rejectReason?.other_reason}
                  onChange={(e)=> setRejectReason((prev)=>({...prev,id:0,value:rejectReason?.value,other_reason:e.target.value}))}
                />
                <label
                  data-label="Other (Requires Comment)"
                  className="form-label"
                ></label>
              </div>
            </fieldset>}
          </div>
          <div className="btn-save-remarks m-lg-t">
            <button type="button" className="btn-primary" onClick={()=>cancelCustomerTask()} disabled={rejectReason?.id === 0 ? !rejectReason?.other_reason : !rejectReason?.value}>
              Save
            </button>
          </div>
        </Modal>
      </div>

      <div className="view-login-popup caluction-popup-outer cancellation-flow">
        <Modal
          show={reopenModal}
          handleClose={hideReopenModal}
        >
          <div className='mrp-heading-txt'>
          <h2 className='mmvdetailsph-title'>Reopen Customer Tasks</h2>
          </div>
          <div className="modal-header">
          </div>
          <div className="modal-body">
            <fieldset className="single-select">
              <div className="material">
                <Select
                  components={{ ValueContainer: CustomValueContainer }}
                  options={REOPEN_REASONS}
                  placeholder="Reopen Reasons"
                  className="react-select"
                  classNamePrefix="react-select"
                  value={REOPEN_REASONS?.filter(v=> v.value === reopenReason?.value)}
                  onChange={(e) =>
                    setReopenReason((prev)=>({...prev,id:e.id,value:e.value,}))
                  }
                />
              </div>
            </fieldset>
            &nbsp;
            &nbsp;
            {reopenReason?.id === 0 && 
            <fieldset className="form-filed">
              <div className="material">
                <input
                  id="value"
                  type="text"
                  placeholder=""
                  name="value"
                  className="form-input"
                  autoComplete="off"
                  value={reopenReason?.other_reason}
                  onChange={(e)=> setReopenReason((prev)=>({...prev,id:0,value:reopenReason?.value,other_reason:e.target.value}))}
                />
                <label
                  data-label="Other (Requires Comment)"
                  className="form-label"
                ></label>
              </div>
            </fieldset>}
          </div>
          <div className="btn-save-remarks m-lg-t">
            <button type="button" className="btn-primary" onClick={()=>reopenCustomerTask()} disabled={reopenReason?.id === 0 ? !reopenReason?.other_reason : !reopenReason?.value}>
              Save
            </button>
          </div>
        </Modal>
      </div>

    </>
  );
};

const Modal = ({ handleClose, show, children }) => {
  const showHideClassName = show
    ? 'modal display-block'
    : 'modal display-none';

  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        {children}
        <button
          onClick={handleClose}
          className="close_icn"
        >
          <i className="ic-clearclose"></i>
        </button>
      </section>
    </div>
  );
};

export default CustomerListTable;
